import React from 'react';
import Symbol from '../../webcommon/common/symbols/Symbol';
import { createExpanderCell } from '../../webcommon/grid/gridcomponents';
import TitleCell from './CustomCells/TitleCell';

const SensitivtyComponent = createExpanderCell(() => null, undefined, (row, gridProps) => {
    gridProps.onExpanderClick(row);
});

const RenderCSA = (row, value) => (row.original.imModel
     && row.original.titleRow === true ? '' : (value));

const mappings = [
    {
        id: 'imModel',
        title: 'IM Model',
        expander: true,
        draggable: false,
        hideable: false,
        renderCell: (row) => {
            const val = row.original.titleRow ? `${row.original.imModel} - ${row.original.counterparty}` : row.original.imModel;

            if (row.original.imModel) {
                if (row.original.children && row.original.children.length) {
                    return <SensitivtyComponent { ...row } value={ val || '' } />;
                }
                return (
                    <TitleCell
                        value={ val.toString() }
                        titleRow={ row.original.titleRow === true }
                    />
                );
            }
            return '';
        }
    },
    {
        id: 'silo',
        title: 'Silo',
        expander: true,
        draggable: false,
        hideable: false,
        noPadding: true
    },
    {
        id: 'riskClass',
        title: 'Risk Class',
        expander: true,
        draggable: false,
        hideable: false,
        noPadding: true
    },
    {
        id: 'senstivity',
        title: 'Sensitivty Type',
        expander: true,
        draggable: false,
        hideable: false,
        noPadding: true,
        renderCell: (row) => {
            if (row.original.senstivity) {
                if (row.original.children.length) {
                    return <SensitivtyComponent { ...row } value={ row.value || '' } />;
                }
                return row.value || row.value === 0 ? row.value : '';
            }
            return '';
        }
    },
    {
        id: 'bucket',
        title: 'Bucket',
        draggable: false,
        hideable: false,
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value : '')
    },
    {
        id: 'trades',
        title: 'Trades',
        draggable: true,
        hideable: true,
        type: 'number',
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value.toLocaleString() : '')
    },
    {
        id: 'imPledgeUsd',
        title: 'IM Pledge',
        draggable: true,
        hideable: true,
        type: 'number',
        symbol: 'USD',
        Header: header => <Symbol symbol="USD">{header.column.title}</Symbol>,
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value.toLocaleString() : '')
    },
    {
        id: 'imReceiveUsd',
        title: 'IM Receive',
        draggable: true,
        hideable: true,
        type: 'number',
        symbol: 'USD',
        Header: header => <Symbol symbol="USD">{header.column.title}</Symbol>,
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value.toLocaleString() : '')
    },
    {
        id: 'imPledgeEur',
        title: 'IM Pledge',
        draggable: true,
        hideable: true,
        type: 'number',
        symbol: 'EUR',
        Header: header => <Symbol symbol="EUR">{header.column.title}</Symbol>,
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value.toLocaleString() : '')
    },
    {
        id: 'imReceiveEur',
        title: 'IM Receive',
        draggable: true,
        hideable: true,
        type: 'number',
        symbol: 'EUR',
        Header: header => <Symbol symbol="EUR">{header.column.title}</Symbol>,
        renderCell: row => RenderCSA(row, row.value || row.value === 0 ? row.value.toLocaleString() : '')
    }
];

export default mappings;
